<template>
  <!--<div style="text-align: left; display: flex; flex-direction: row; justify-content: space-between; align-items: center;  border: 0px solid #383838;">       
    <a href="javascript:void(0)" style="font-size: 24px; color: black;" @click="$router.push('/')">
      <img src="../assets/eta-small.png" alt="" style="width: 50px; top: -5px; position: relative;">
    </a>
    <h3>
     Welcome {{$store.getters.getAccessToken.full_name}}
    </h3>
    <a href="javascript:void(0)" @click="$store.dispatch('logout')" style="font-size: 18px; color: black;">Logout</a>
  </div>-->
  <div style="text-align: left; display: flex; flex-direction: column;">    
  
  <div style="text-align: left; display: flex; flex-direction: row; justify-content: space-between; align-items: center;  border: 0px solid #383838;">    
   
    <div style="width: 50%; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">    
    <el-menu 
      :mode="'horizontal'" 
      @select="handleSelect" 
      :style="'margin-top: -10px;'">
      <el-menu-item index="homepage"><img :src="'https://etacdn.b-cdn.net/eta-small.png'" alt="" style="width: 50px; top: -5px; position: relative;"></el-menu-item>
      <el-submenu 
        style="font-size: 12px; font-weight: 500;">
        <template slot="title">Sales</template>
            <el-menu-item 
                :router="true"
                :index="'/leads'" style="text-align: left;">
                <span>
                  Leads
                </span>
            </el-menu-item> 
            <el-menu-item 
                v-if="$store.getters.getAccessToken.user_type === 0"
                :router="true"
                :index="'/tenants'" style="text-align: left;">
                <span>
                  Tenants
                </span>
            </el-menu-item>  
            <el-menu-item 
                v-if="$store.getters.getAccessToken.user_type === 0"
                :router="true"
                :index="'/whatsapp'" style="text-align: left;">
                <span>
                  WhatsApp
                </span>
            </el-menu-item>  
            <el-menu-item 
                v-if="$store.getters.getAccessToken.user_type === 0"
                :router="true"
                :index="'/payments'" style="text-align: left;">
                <span>
                  Payments
                </span>
            </el-menu-item>                     
      </el-submenu>
    </el-menu>
    </div>
    
    <div style="width: 50%; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
      <el-menu 
        mode="horizontal" 
        @select="handleSelect" 
        style="margin-top: -10px;">
        <el-submenu 
          :index="'settings'"
          style="font-size: 12px; font-weight: bold; color: black;">
          <template slot="title"><span style="margin-left: 5px;">{{$store.getters.getAccessToken.full_name}}</span></template>
            <el-menu-item 
              :router="true"
              :index="'/changepassword'" style="text-align: left;">
              Change Password
            </el-menu-item>
            <el-menu-item 
              :router="true"
              :index="'/logout'" style="text-align: left;">
              Logout
            </el-menu-item>           
        </el-submenu>
      </el-menu>
    </div>

  </div>
    <el-breadcrumb :separator="'/'" style="top: 10px; position: relative; background-color: #eee; padding: 10px; border-radius: 25px;">
            
        <el-breadcrumb-item 
          v-for="(data, index) in getBreadCrumbs"
          :key="index">
          <span style=" color: #383838; font-size: 14px;">
            {{ data.crumb_name}}
          </span>
        </el-breadcrumb-item>        
    </el-breadcrumb>
  </div>
</template>

<script>

export default {
    data() {
      return {
        activeIndex: '1',
        show_calendar: false,
        show_renew: true,
        show_menu: false,
        show_stock_search: false,
        current_path: '/',
        bread_crumbs: []
      }
    },
    computed: {
      getBreadCrumbs() {
        return this.bread_crumbs
      }
    },
    methods: {
        handleSelect(key) {
            this.handleRouteChange(key)
        },
        handleRouteChange(routePath) {
          this.current_path = routePath
          this.bread_crumbs = [{
            crumb_name: 'Dashboard'
          }]
          if(routePath == 'homepage') {
            this.$router.push('/')
          } else {
            this.$router.push(routePath)
          }
          
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/MainMenu.vue